import React from 'react';
import { observer } from 'mobx-react';
import { ButtonWithDropdown } from 'components';
import { DfMIcon } from 'icons';
import { themes } from 'styles/themes/wikifactoryNew';
import { useViewerControl } from 'libs/rendering/gltf/hooks';
import { useChatControl } from 'libs/rendering/hooks';
import { analytics } from 'core/analytics';
import { useRouterStore } from 'apps/hooks';
import { renderCustomIcon } from 'utils/jsxUtils';
import { OperatorWrapper } from './CADButtonWrapper';

export const DfMButton = observer(() => {
  const viewerControl = useViewerControl();
  const { route, navigate } = useRouterStore();
  const chatControl = useChatControl();

  const isActive = viewerControl.meshAnalysis?.visible;

  // DFM
  function toggleDfmAnalysis() {
    const newParams = Object.assign({}, route.params);
    // close other panels
    if (newParams.panel === 'discuss') {
      chatControl.chatVisible = false;
    }

    // open DFM pannel
    if (newParams.panel === 'dfm') {
      delete newParams.panel;
      analytics.sendEvent('dfm-tool-hide');
    } else {
      newParams.panel = 'dfm';
      analytics.sendEvent('dfm-tool-show');
    }

    navigate(route.name, newParams, {
      replace: true,
    });
  }

  return (
    <OperatorWrapper
      isActive={isActive}
      className='rounded border border-wfGrey100'
    >
      <ButtonWithDropdown
        renderIcon={isHover =>
          renderCustomIcon(DfMIcon, {
            isHover,
            isActive,
            activeFillColor: themes.color.wfBlue,
          })
        }
        tooltip='DFM Analysis'
        data-testid='CADPage-DfMAnalysis'
        onClick={() => {
          toggleDfmAnalysis();
        }}
        isActive={isActive}
        hasDropdown={false}
        borderRight='none'
      />
    </OperatorWrapper>
  );
});
